var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "time-input" },
    [
      _vm.mode === "edit"
        ? _c("DurationInput", {
            ref: "refTimeInput",
            attrs: {
              value: _vm.currentValue,
              placeholder: _vm.placeholderFormat,
              lazyMask: true,
              useSecond: _vm.useSecond
            },
            on: {
              "update:value": function(updatedValue) {
                return (_vm.currentValue = updatedValue)
              }
            }
          })
        : _c("p", [_vm._v("\n        " + _vm._s(_vm.currentValue) + "\n    ")])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }